<template>
    <div class='container d-flex'>
        <!-- {{ search_list.length }} -->
        <!-- 排序 -->
        <div class="sort">
            <ul class="list-unstyled mb-0 d-flex">
                <li @click="newsort()" :class="sorts == 1 ? 'active' : ''"><span>搜索{{ this.$route.params.name }}的結果</span>
                </li>
                <li @click="discountsort()" :class="sorts == 2 ? 'active' : ''"><span>折扣商品</span></li>
                <li @click="sort('asc')" :class="sorts == 3 ? 'active' : ''"><span>價格升序</span></li>
                <li @click="sort('desc')" :class="sorts == 4 ? 'active' : ''"><span>價格降序</span></li>
            </ul>
            <!-- <div style="text-align: center;">搜索{{this.$route.params.name}}的結果：</div> -->
        </div>
        <span style="color: red;">
            💡點選圖片查看商品詳情💡
        </span>
        <div v-if="search_list.length != 0" class="issearch">
            <!-- item -->
            <ul class="list-unstyled d-grid shop-item mb-0">
                <li v-for="item, index in sort_search_list">

                    <div @click="godetails(item.oig_id)" style="cursor: pointer ; ">

                        <ImageLoader :key="index" :imageSrc="isMobile ? item.images_mobile : item.images" class="img" :altText="item.group_name" />
                    </div>
                    <div style="padding: 10px;">
                        <div class="name">{{ item.group_name }}</div>
                        <div v-if="item.price_original_max - item.price_max != 0" class="price">
                            <del style="font-size: 12px;">${{ item.price_original_max | formatNumberToqff }} </del>
                            <div class="special" > ${{ item.price_max | formatNumberToqff }}
                            </div>
                        </div>
                        <div class="price" style="min-height: 48px;" v-else>
                            <div class="special">${{ item.price_original_max | formatNumberToqff }}
                            </div>
                        </div>
                        <!-- <div class="price">${{item.price_min | formatNumberToqff}}</div> -->
                        <div
                            :style="[{ textAlign: 'center' }, { bottom: '0px' }, { width: '100%' }, { position: 'relative' }]">
                            <!-- <span @click.stop="getdetails(item.oig_id)" data-bs-toggle="modal"
                                :data-bs-target="'#m' + item.oig_id">立即訂購👉</span> -->
                            <div class="icon" data-bs-toggle="modal" @click.stop="getdetails(item.oig_id)"
                                :data-bs-target="'#m' + item.oig_id">
                                <i class="icon-new_cart"></i>
                            </div>
                        </div>
                    </div>
                    <shopmodal :value="item" ref="details"></shopmodal>
                </li>
            </ul>
            <!-- 页码 -->
            <div class="d-flex justify-content-center align-items-center page">
                <ul class="pt_pagination_list d-flex align-items-center list-unstyled mb-0" style="">

                </ul>
            </div>
        </div>
        <div v-else class="nosearch">
            <div class="no_data">
                <div class="d-flex align-items-center justify-content-center">
                    <i class="icon-new_product mr-5"></i>
                    <span>目前無與搜索相關的任何商品</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import $ from 'jquery'
import shopmodal from '@/components/modal/Shop.vue'
import numeral from "numeral";
import { mapState } from 'vuex';
import ImageLoader from '@/components/Image_loading.vue'
export default {
    components: { shopmodal, ImageLoader },
    data() {
        return {
            sorts: 1,
            judgment: false,
            isMobile: false
        };
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    computed: {
        ...mapState('commodity', ['search_list', 'sort_search_list'])
    },
    watch: {},
    methods: {
        godetails(e) {
            this.$store.dispatch('commodity/getdesignated_product', e).then(response => {
                this.$router.push({
                    path: `/details/${e}`,
                }).catch(err => { })
            });
        },
        getdetails(e) {
            this.$refs.details.forEach(element => {
                if (element.value.oig_id == e) {
                    // console.log(y);
                    element.getitem();
                }
                // console.log(element.value.oig_id==e);
            })
        },
        // 价格排序
        sort(e) {
            if (e == 'desc') {
                this.sorts = 4;
            } else {
                this.sorts = 3;
            }
            let x = this.search_list
            // let x= _.orderBy(this.search_list, ['price_min'], [e]);
            this.$store.commit('commodity/set_sort_search_list', _.orderBy(x, ['price_max'], [e]))
            // console.log(x);
        },
        // 最新上架
        newsort() {
            this.sorts = 1;
            this.$store.commit('commodity/set_sort_search_list', this.search_list)
        },
        // 折扣商品
        discountsort() {
            this.sorts = 2;
            let x = this.search_list;
            let y = [];
            let z = [];
            x.forEach(element => {
                //    console.log(element); 
                if (element.price_original_max - element.price_max != 0) {
                    y.push(element)
                } else {
                    z.push(element)
                }
            });
            // console.log();
            this.$store.commit('commodity/set_sort_search_list', y.concat(z))

        }
    },
    created() {
    },
    mounted() {
        this.$store.dispatch('commodity/getsearch', this.$route.params.name)
        if (window.innerWidth > 600) {
            this.isMobile = false;
        } else {
            this.isMobile = true;

        }
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>